import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconActionChevronDownSmall16, IconActionChevronUpSmall16 } from '@cian/ui-kit-design-tokens/icons';

export interface IRoomStatsToggleButtonProps {
  expanded: boolean;
  onClick: () => void;
  size?: React.ComponentProps<typeof Button>['size'];
}

export const RoomStatsToggleButton = ({
  expanded,
  onClick,
  size = 'XS',
}: IRoomStatsToggleButtonProps): React.JSX.Element => (
  <Button
    afterIcon={
      expanded ? (
        <IconActionChevronUpSmall16 color="current_color" />
      ) : (
        <IconActionChevronDownSmall16 color="current_color" />
      )
    }
    size={size}
    theme="main_secondary"
    onClick={onClick}
  >
    {expanded ? 'Свернуть' : 'Показать больше'}
  </Button>
);
